/* jshint esversion: 9 */
/**
 * Logistics Businesss : 物流业务管理
 *
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/lgit/v1/{organizationId}/logistics-businesss',
  items: [
    { key: 'addLogisticsBusiness', url: '', method: 'POST' },
    { key: 'deleteLogisticsBusiness', url: '', method: 'DELETE' },
    { key: 'updateLogisticsBusiness', url: '', method: 'PUT' },
    { key: 'updateCsgEnableFlag', url: '/updateCsgEnableFlag', method: 'PUT' },
    { key: 'getLogisticsBusiness', url: '', method: 'GET', loadingHide: true },
    { key: 'getLogisticsBusiness2', url: '/all', method: 'GET' },
    { key: 'detailLogisticsBusiness', url: '/', method: 'GET' },
    
    // 物流商/物流业务/Setting按钮 详情页/title数据  get /v1/{organizationId}/logistics-businesss/{id}
    { key: 'detailLogisticsBusinessSetting', url: '/{id}', method: 'GET' },
    // 物流商/物流业务/Setting按钮 详情页/分区tab页 数据回显  get /v1/{organizationId}/logistics-businesss/get-customer-logistics-group-dict/{businessId}
    { key: 'getCustomerLogisticsGroupDict', url: '/get-customer-logistics-group-dict/{businessId}', method: 'GET' },
    // 物流商/物流业务/Setting按钮 详情页/分区tab页 保存  post /v1/{organizationId}/logistics-businesss/set-customer-logistics-group-dict
    { key: 'setCustomerLogisticsGroupDict', url: '/set-customer-logistics-group-dict', method: 'POST' },
  ],
};
export default {
  ...generate(config),
};
